export default function extractStyleParams(element) {
  let style = {};
  let length = element.attributes.length;

  for (var i = 0; i < length; i++) {
    let item = element.attributes.item(i);
    if (item.name.match(/data-dubbletrack-style/)) {
      let name = item.name.replace('data-dubbletrack-style-', '');

      let parts = name.split('-');
      let lastSegment = parts.pop()
      if (lastSegment == "color") {
        parts.unshift(lastSegment);
      } else {
        parts.push(lastSegment);
      }

      if (item.value.match(/^[0-9]+/)) {
        style[parts.join('-')] = `#${item.value}`;
      } else {
        style[parts.join('-')] = item.value;
      }


    }
  }

  return style;
}
